export default __webpack_public_path__ + "static/media/outside-reverse.8a637004.mp4";